import React, { useState, useEffect } from 'react'
import Header from '../users/Header'
import NavHeader from '../users/NavHeader'
import { UserAuth } from '../../context/AuthContext'
import { BsTelegram, BsTwitter, BsFacebook, BsYoutube, BsMedium, BsReddit } from 'react-icons/bs';
import { SiGmail } from 'react-icons/si';
import { FaDiscord, FaUserAstronaut } from 'react-icons/fa';
import { BsCaretDownFill, BsCaretUpFill } from 'react-icons/bs';
import validator from 'validator'

const Tambah = () => {

  const { user, addPasukan } = UserAuth();

  const [error, setError] = useState('');
  const [nohpTelegram, setNohpTelegram] = useState('');
  const [usernameTelegram, setUsernameTelegram] = useState('');
  const [twitter, setTwitter] = useState('');
  const [email, setEmail] = useState('');
  const [facebook, setFacebook] = useState('');
  const [youtube, setYoutube] = useState('');
  const [medium, setMedium] = useState('');
  const [reddit, setReddit] = useState('');
  const [discord, setDiscordd] = useState('');
  const [showInput, setShowInput] = useState();

  /* Handle Form Input */
  const setHandleInput = (id, e) => {
    if (id === 'nohpTelegram') {
      setNohpTelegram(e.target.value);
    } else if (id === 'usernameTelegram') {
      setUsernameTelegram(e.target.value);
    } else if (id === 'twitter') {
      setTwitter(e.target.value);
    } else if (id === 'email') {
      setEmail(e.target.value);
    } else if (id === 'facebook') {
      setFacebook(e.target.value);
    } else if (id === 'youtube') {
      setYoutube(e.target.value);
    } else if (id === 'medium') {
      setMedium(e.target.value);
    } else if (id === 'reddit') {
      setReddit(e.target.value);
    } else if (id === 'discord') {
      setDiscordd(e.target.value);
    }
  };

  /* Form Data */
  const formData = [
    { id: 'nohpTelegram', title: 'Telegram', color: 'text-telegram', icon: <BsTelegram />, desc: 'Masukkan No. Hp Telegram' },
    { id: 'usernameTelegram', title: '*Username Telegram (Harus diisi)', color: 'text-telegram', icon: <BsTelegram />, desc: 'Masukkan Username Telegram' },
    { id: 'twitter', title: '*Twitter (Harus diisi)', color: 'text-twitter', icon: <BsTwitter />, desc: 'Masukkan Link/Username Twitter' },
    { id: 'email', title: 'Email / Gmail', color: 'text-gmail', icon: <SiGmail />, desc: 'Masukkan Alamat Email' },
  ]

  const formData2 = [
    { id: 'discord', title: 'Discord', color: 'text-discord', icon: <FaDiscord />, desc: 'Masukkan Username Discord' },
    { id: 'facebook', title: 'Facebook', color: 'text-facebook', icon: <BsFacebook />, desc: 'Masukkan Link Facebook' },
    { id: 'youtube', title: 'Youtube', color: 'text-youtube', icon: <BsYoutube />, desc: 'Masukkan Link Channel Youtube' },
    { id: 'medium', title: 'Medium', color: 'text-black', icon: <BsMedium />, desc: 'Masukkan Link Medium' },
    { id: 'reddit', title: 'Reddit', color: 'text-reddit', icon: <BsReddit />, desc: 'Masukkan Link Reddit' }
  ]

  /* Render Form */
  const formElement = formData.map((hasil, i) =>
    <label className="block">
      <span className="text-zinc-700 text-sm font-medium">{hasil.title}</span>
      <div className="relative">
        <span className="absolute inset-y-0 left-0 pl-0 flex items-center text-zinc-500 icon">
          {hasil.icon}
        </span>
        <input onChange={(e) => {
          setHandleInput(hasil.id, e)
          const icon = e.target.parentNode.querySelector(".icon");
          if (hasil.color !== undefined) {
            if (e.target.value) {
              icon.classList.remove('text-zinc-500');
              icon.classList.add(hasil.color);
            } else {
              icon.classList.add('text-zinc-500');
              icon.classList.remove(hasil.color);
            }
          }
        }} type="text" placeholder={hasil.desc} className="mt-0 block w-full font-normal  text-zinc-900 text-sm pl-6 pr-1 px-1 border-0 border-b border-gray-300 focus:ring-0 focus:border-zinc-600" autoComplete="off" />
      </div>
    </label>
  );

  const formElement2 = formData2.map((hasil, i) =>
    <label className="block">
      <span className="text-zinc-700 text-sm font-medium">{hasil.title}</span>
      <div className="relative">
        <span className="absolute inset-y-0 left-0 pl-0 flex items-center text-zinc-500 icon">
          {hasil.icon}
        </span>
        <input onChange={(e) => {
          setHandleInput(hasil.id, e)
          const icon = e.target.parentNode.querySelector(".icon");
          if (hasil.color !== undefined) {
            if (e.target.value) {
              icon.classList.remove('text-zinc-500');
              icon.classList.add(hasil.color);
            } else {
              icon.classList.add('text-zinc-500');
              icon.classList.remove(hasil.color);
            }
          }
        }} type="text" placeholder={hasil.desc} className="mt-0 block w-full font-normal  text-zinc-900 text-sm pl-6 pr-1 px-1 border-0 border-b border-gray-300 focus:ring-0 focus:border-zinc-600" autoComplete="off" />
      </div>
    </label>
  );

  const uname = user.displayName;

  const [loading, setLoading] = useState();

  const [showNotification, setShowNotification] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowNotification(false);
    setLoading(true);
    try {
      const maxLength = 96;
      if (nohpTelegram !== "" && !validator.isMobilePhone(nohpTelegram)) {
        throw new Error('No. Hp. Telegram tidak valid');
      }
      if (!usernameTelegram) {
        throw new Error('Username Telegram harus diisi');
      }
      if (!twitter) {
        throw new Error('Link/Username Twitter harus diisi ')
      }
      if (
        nohpTelegram?.length >= maxLength && usernameTelegram?.length >= maxLength &&
        twitter?.length >= maxLength && email?.length >= maxLength &&
        facebook?.length >= maxLength && youtube?.length >= maxLength &&
        medium?.length >= maxLength && reddit?.length >= maxLength && discord?.length >= maxLength
      ) {
        throw new Error('Input value tidak boleh lebih dari 96 karakter')
      }
      if (twitter.length < 4) {
        throw new Error('Username Twitter harus lebih dari 4 karakter')
      }
      if (usernameTelegram.length < 5) {
        throw new Error('Username Telegram harus lebih dari 5 karakter')
      }
      const result = await addPasukan(
        uname,
        nohpTelegram, usernameTelegram,
        twitter, email, facebook,
        youtube, medium, reddit, discord)
      if (result === true) {
        setShowNotification(true);
        setError('Pasukan berhasil ditambahkan');
      } else {
        throw new Error(result)
      }
    } catch (e) {
      setShowNotification(true);
      setError(e.message);
    } finally {
      setLoading(false);
      setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
    }
  }
  return (
    <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
      <NavHeader />
      <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
        <Header />
        {loading && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
            <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
          </div>
        )}
        {showNotification && (
          <div className="px-4 fixed bottom-[50px] w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
            <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
              {error}
              <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
            </div>
          </div>
        )}
        <div className='pt-3 pb-[96px]'>
          <div className='bg-white'>
            <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center border-b-4 border-slate-100'>
              <div className='flex items-center'>
                <span className="mr-2">
                  <FaUserAstronaut className='h-[14px] w-[14px] md:h-[16px] md:w-[16px]' />
                </span>
                <h1 className='font-semibold text-base md:text-lg'>Tambah Pasukan</h1>
              </div>
              <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                Pelajari
              </div>
            </div>
            <div className='px-4 py-6'>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 gap-4">
                  {formElement}
                  <label className="block cursor-pointer">
                    {showInput ? (
                      <span className="text-zinc-500 text-sm font-medium flex items-center" onClick={() => setShowInput(!showInput)}>
                        Isi Juga ... FB, Youtube, Medium Reddit, Discord
                        <BsCaretUpFill className='ml-1 fill-current text-gray-400' size='14' />
                      </span>
                    ) : (
                      <span className="text-zinc-500 text-sm font-medium flex items-center" onClick={() => setShowInput(!showInput)}>
                        Isi Juga ... FB, Youtube, Medium Reddit, Discord
                        <BsCaretDownFill className='ml-1 fill-current text-gray-400' size='14' />
                      </span>
                    )}
                  </label>
                  {showInput && formElement2}
                </div>
                <div className='max-w-[600px] mx-auto bottom-0 fixed left-0 right-0 border-t bg-white p-4'>
                  <button className="w-full py-2 rounded-md font-semibold text-white bg-primary flex flex-row justify-center items-center hover:bg-secondary focus:outline-none focus:bg-secondary" type="submit">Tambah Pasukan</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tambah